// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCfgV2Products (params?: {}): Promise<Dict>;
    publicGetCfgFundingRates (params?: {}): Promise<List>;
    publicGetProducts (params?: {}): Promise<Dict>;
    publicGetNomicsTrades (params?: {}): Promise<Dict>;
    publicGetMdKline (params?: {}): Promise<Dict>;
    publicGetMdV2KlineList (params?: {}): Promise<Dict>;
    publicGetMdV2Kline (params?: {}): Promise<Dict>;
    publicGetMdV2KlineLast (params?: {}): Promise<Dict>;
    publicGetMdOrderbook (params?: {}): Promise<Dict>;
    publicGetMdTrade (params?: {}): Promise<Dict>;
    publicGetMdSpotTicker24hr (params?: {}): Promise<Dict>;
    publicGetExchangePublicCfgChainSettings (params?: {}): Promise<Dict>;
    v1GetMdFullbook (params?: {}): Promise<Dict>;
    v1GetMdOrderbook (params?: {}): Promise<Dict>;
    v1GetMdTrade (params?: {}): Promise<Dict>;
    v1GetMdTicker24hr (params?: {}): Promise<Dict>;
    v1GetMdTicker24hrAll (params?: {}): Promise<Dict>;
    v1GetMdSpotTicker24hr (params?: {}): Promise<Dict>;
    v1GetMdSpotTicker24hrAll (params?: {}): Promise<Dict>;
    v1GetExchangePublicProducts (params?: {}): Promise<Dict>;
    v1GetApiDataPublicDataFundingRateHistory (params?: {}): Promise<Dict>;
    v2GetPublicProducts (params?: {}): Promise<Dict>;
    v2GetPublicProductsPlus (params?: {}): Promise<Dict>;
    v2GetPublicIndexSources (params?: {}): Promise<Dict>;
    v2GetMdV2Orderbook (params?: {}): Promise<Dict>;
    v2GetMdV2Trade (params?: {}): Promise<Dict>;
    v2GetMdV2Ticker24hr (params?: {}): Promise<Dict>;
    v2GetMdV2Ticker24hrAll (params?: {}): Promise<Dict>;
    v2GetApiDataPublicDataFundingRateHistory (params?: {}): Promise<Dict>;
    privateGetSpotOrdersActive (params?: {}): Promise<Dict>;
    privateGetSpotOrders (params?: {}): Promise<Dict>;
    privateGetSpotWallets (params?: {}): Promise<Dict>;
    privateGetExchangeSpotOrder (params?: {}): Promise<Dict>;
    privateGetExchangeSpotOrderTrades (params?: {}): Promise<Dict>;
    privateGetExchangeOrderV2OrderList (params?: {}): Promise<Dict>;
    privateGetExchangeOrderV2TradingList (params?: {}): Promise<Dict>;
    privateGetAccountsAccountPositions (params?: {}): Promise<Dict>;
    privateGetGAccountsAccountPositions (params?: {}): Promise<Dict>;
    privateGetGAccountsPositions (params?: {}): Promise<Dict>;
    privateGetGAccountsRiskUnit (params?: {}): Promise<Dict>;
    privateGetApiDataFuturesFundingFees (params?: {}): Promise<Dict>;
    privateGetApiDataGFuturesFundingFees (params?: {}): Promise<Dict>;
    privateGetApiDataFuturesOrders (params?: {}): Promise<List>;
    privateGetApiDataGFuturesOrders (params?: {}): Promise<List>;
    privateGetApiDataFuturesOrdersByOrderId (params?: {}): Promise<List>;
    privateGetApiDataGFuturesOrdersByOrderId (params?: {}): Promise<Dict>;
    privateGetApiDataFuturesTrades (params?: {}): Promise<List>;
    privateGetApiDataGFuturesTrades (params?: {}): Promise<List>;
    privateGetApiDataFuturesTradingFees (params?: {}): Promise<List>;
    privateGetApiDataGFuturesTradingFees (params?: {}): Promise<List>;
    privateGetApiDataFuturesV2TradeAccountDetail (params?: {}): Promise<List>;
    privateGetApiDataGFuturesClosedPosition (params?: {}): Promise<Dict>;
    privateGetGOrdersActiveList (params?: {}): Promise<Dict>;
    privateGetOrdersActiveList (params?: {}): Promise<Dict>;
    privateGetExchangeOrderList (params?: {}): Promise<Dict>;
    privateGetExchangeOrder (params?: {}): Promise<Dict>;
    privateGetExchangeOrderTrade (params?: {}): Promise<Dict>;
    privateGetPhemexUserUsersChildren (params?: {}): Promise<Dict>;
    privateGetPhemexUserWalletsV2DepositAddress (params?: {}): Promise<Dict>;
    privateGetPhemexUserWalletsTradeAccountDetail (params?: {}): Promise<Dict>;
    privateGetPhemexDepositWalletsApiDepositAddress (params?: {}): Promise<Dict>;
    privateGetPhemexDepositWalletsApiDepositHist (params?: {}): Promise<Dict>;
    privateGetPhemexDepositWalletsApiChainCfg (params?: {}): Promise<Dict>;
    privateGetPhemexWithdrawWalletsApiWithdrawHist (params?: {}): Promise<Dict>;
    privateGetPhemexWithdrawWalletsApiAssetInfo (params?: {}): Promise<Dict>;
    privateGetPhemexUserOrderClosedPositionList (params?: {}): Promise<Dict>;
    privateGetExchangeMarginsTransfer (params?: {}): Promise<Dict>;
    privateGetExchangeWalletsConfirmWithdraw (params?: {}): Promise<Dict>;
    privateGetExchangeWalletsWithdrawList (params?: {}): Promise<Dict>;
    privateGetExchangeWalletsDepositList (params?: {}): Promise<Dict>;
    privateGetExchangeWalletsV2DepositAddress (params?: {}): Promise<Dict>;
    privateGetApiDataSpotsFunds (params?: {}): Promise<Dict>;
    privateGetApiDataSpotsOrders (params?: {}): Promise<Dict>;
    privateGetApiDataSpotsOrdersByOrderId (params?: {}): Promise<Dict>;
    privateGetApiDataSpotsPnls (params?: {}): Promise<List>;
    privateGetApiDataSpotsTrades (params?: {}): Promise<List>;
    privateGetApiDataSpotsTradesByOrderId (params?: {}): Promise<List>;
    privateGetAssetsConvert (params?: {}): Promise<Dict>;
    privateGetAssetsTransfer (params?: {}): Promise<Dict>;
    privateGetAssetsSpotsSubAccountsTransfer (params?: {}): Promise<List>;
    privateGetAssetsFuturesSubAccountsTransfer (params?: {}): Promise<List>;
    privateGetAssetsQuote (params?: {}): Promise<Dict>;
    privateGetPhemexLbPublicApiTraderPerformanceInfo (params?: {}): Promise<Dict>;
    privateGetUtaApiRiskRiskMode (params?: {}): Promise<Dict>;
    privateGetUtaApiRiskRiskUnits (params?: {}): Promise<Dict>;
    privateGetUtaBizAssets (params?: {}): Promise<Dict>;
    privateGetUtaFundsContractBorrow (params?: {}): Promise<Dict>;
    privateGetUtaFundsContractPayback (params?: {}): Promise<Dict>;
    privateGetUtaFundsContractBorrowInterests (params?: {}): Promise<Dict>;
    privateGetUtaExchangerAssetsConvert (params?: {}): Promise<Dict>;
    privatePostSpotOrders (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostGOrders (params?: {}): Promise<Dict>;
    privatePostPositionsAssign (params?: {}): Promise<Dict>;
    privatePostExchangeWalletsTransferOut (params?: {}): Promise<Dict>;
    privatePostExchangeWalletsTransferIn (params?: {}): Promise<Dict>;
    privatePostExchangeMargins (params?: {}): Promise<Dict>;
    privatePostExchangeWalletsCreateWithdraw (params?: {}): Promise<Dict>;
    privatePostExchangeWalletsCancelWithdraw (params?: {}): Promise<Dict>;
    privatePostExchangeWalletsCreateWithdrawAddress (params?: {}): Promise<Dict>;
    privatePostAssetsTransfer (params?: {}): Promise<Dict>;
    privatePostAssetsSpotsSubAccountsTransfer (params?: {}): Promise<Dict>;
    privatePostAssetsFuturesSubAccountsTransfer (params?: {}): Promise<Dict>;
    privatePostAssetsUniversalTransfer (params?: {}): Promise<Dict>;
    privatePostAssetsConvert (params?: {}): Promise<Dict>;
    privatePostPhemexWithdrawWalletsApiCreateWithdraw (params?: {}): Promise<Dict>;
    privatePostPhemexWithdrawWalletsApiCancelWithdraw (params?: {}): Promise<Dict>;
    privatePostUtaAccountSwitchMode (params?: {}): Promise<Dict>;
    privatePostUtaFundsContractPayback (params?: {}): Promise<Dict>;
    privatePutSpotOrdersCreate (params?: {}): Promise<Dict>;
    privatePutSpotOrders (params?: {}): Promise<Dict>;
    privatePutOrdersReplace (params?: {}): Promise<Dict>;
    privatePutGOrdersReplace (params?: {}): Promise<Dict>;
    privatePutGOrdersCreate (params?: {}): Promise<Dict>;
    privatePutPositionsLeverage (params?: {}): Promise<Dict>;
    privatePutGPositionsLeverage (params?: {}): Promise<Dict>;
    privatePutGPositionsSwitchPosModeSync (params?: {}): Promise<Dict>;
    privatePutPositionsRiskLimit (params?: {}): Promise<Dict>;
    privateDeleteSpotOrders (params?: {}): Promise<Dict>;
    privateDeleteSpotOrdersAll (params?: {}): Promise<Dict>;
    privateDeleteOrdersCancel (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<Dict>;
    privateDeleteOrdersAll (params?: {}): Promise<Dict>;
    privateDeleteGOrdersCancel (params?: {}): Promise<Dict>;
    privateDeleteGOrders (params?: {}): Promise<Dict>;
    privateDeleteGOrdersAll (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
